import { Tabs, Tab, Box } from "@mui/material";
import { useState } from "react";
import { useRTL } from "hooks/isRTL";
import DriverInfoTab from "./DriverInfoTab";
import DriverOrdersTab from "./DriverOrdersTab";
import DriverOrdersDetails from "./DriverOrdersDetails";

const DriverDetailsTabs = () => {
  const [activeTab, setActiveTab] = useState(0);
  const { t } = useRTL();

  const navItems = [
    { label: t("driverInfo"), component: <DriverInfoTab /> },
    { label: t("driverOrders"), component: <DriverOrdersTab /> },
    { label: t("myRouteOrders"), component: <DriverOrdersDetails /> },
  ];

  const handleTabChange = (_, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Box sx={{ width: "100%", marginTop: "2rem", backgroundColor: "white" }}>
      
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        aria-label="Driver Details Tabs"
        variant="fullWidth"
      >
        {navItems.map((item, index) => (
          <Tab key={index} label={item.label} />
        ))}
      </Tabs>
      <Box sx={{ padding: "1rem" }}>
        {activeTab === 0 && <DriverInfoTab />}
        {activeTab === 1 && <DriverOrdersTab />}
        {activeTab === 2 && <DriverOrdersDetails />}
      </Box>
    </Box>
  );
};

export default DriverDetailsTabs;
